'use strict';

module.exports = {
  ELECTRON_MASS: 5.4857990907e-4,
};
